import { Component } from 'react';
import serviceService from '../Services/serviceService';

class ServiceActualData extends Component {
    state = {
        text: ""
    }

    componentDidMount() {
        serviceService.GetOpportunityServiceActualData(this.props.OpportunityId)
            .then(result => this.setState({ text: result.value }))
            .catch(error => this.setState({ text: "" }));
    }

    render() {
        return (this.state.text);
    }
}

export default ServiceActualData; 